<ng-container *ngIf="(assetValuationsSelection$ | async)?.length !== 0; else noAssetValuations">
    <mat-dialog-content>
        <form [formGroup]="assetValuationsCopyForm">
            <div class="table-scroll-wrapper">
                <table mat-table [dataSource]="(assetValuationsSelection$ | async) ?? []" formArrayName="valuations">
                    <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>Company Name</th>
                        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                            {{element.assetName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dmv">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox color="primary"
                                          [checked]="allDmvSelected()"
                                          [indeterminate]="someDmvSelected()"
                                          (change)="toggleAllDmv($event.checked)">DMV</mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                            <ng-container *ngIf="element.dmv.isCopyAllowed; else copyNotAllowed">
                                <mat-checkbox color="primary" formControlName="copyDmv"></mat-checkbox>
                            </ng-container>
                            <ng-template #copyNotAllowed>
                                <ng-container *ngIf="element.dmv.copyRestrictionMessage === 'No existing DMV to copy'; else showInfoIcon">
                                    <mat-icon
                                        class="copy-restriction-tooltip"
                                        matTooltip="{{element.dmv.copyRestrictionMessage}}"
                                        matTooltipPosition="above">
                                        horizontal_rule
                                    </mat-icon>
                                </ng-container>
                                <ng-template #showInfoIcon>
                                    <mat-icon
                                        class="copy-restriction-tooltip"
                                        matTooltip="{{element.dmv.copyRestrictionMessage}}"
                                        matTooltipPosition="above">
                                        info
                                    </mat-icon>
                                </ng-template>
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fov">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox color="primary"
                                          [checked]="allFovSelected()"
                                          [indeterminate]="someFovSelected()"
                                          (change)="toggleAllFov($event.checked)">FOV</mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                            <ng-container *ngIf="element.fov; else fovDoesNotExist">
                                <ng-container *ngIf="element.fov.isCopyAllowed; else copyNotAllowed">
                                    <mat-checkbox color="primary" formControlName="copyFov"></mat-checkbox>
                                </ng-container>
                                <ng-template #copyNotAllowed>
                                    <mat-icon
                                        class="copy-restriction-tooltip"
                                        matTooltip="{{element.fov.copyRestrictionMessage}}"
                                        matTooltipPosition="above"
                                        color="warn">
                                        info
                                    </mat-icon>
                                </ng-template>
                            </ng-container>
                            <ng-template #fovDoesNotExist>
                                <mat-icon
                                    class="copy-restriction-tooltip"
                                    matTooltip="No existing FOV to copy"
                                    matTooltipPosition="above">
                                    horizontal_rule
                                </mat-icon>
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="preferredValuation">
                        <th mat-header-cell *matHeaderCellDef>Preferred Calculation Base</th>
                        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                            <ng-container *ngIf="filterAvailableValuationTypes(valuationTypes, element, i) as availableValuationTypes">
                                <ng-container *ngIf="availableValuationTypes.length === 1; else showDropdown">
                                    {{filterAvailableValuationTypes(valuationTypes, element, i)[0] | codeFormat: codeTableValuationType | async}}
                                </ng-container>
                                <ng-template #showDropdown>
                                    <select formControlName="preferred">
                                        <option *ngFor="let vt of availableValuationTypes"
                                                [value]="vt">
                                            {{vt | codeFormat: codeTableValuationType | async}}
                                        </option>
                                    </select>
                                </ng-template>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="assetValuationsColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; let i = index; columns: assetValuationsColumns" [formGroupName]="i"></tr>
                </table>
            </div>
        </form>
    </mat-dialog-content>
</ng-container>
<mat-dialog-actions align="end">
    <button
        mat-stroked-button
        (click)="navigateToFundValuationCopyDialog()">
        Back
    </button>
    <button
        mat-stroked-button
        color="primary"
        (click)="navigateToSummaryPage()">
        Next
    </button>
</mat-dialog-actions>
<ng-template #noAssetValuations>
    <mat-dialog-content>
        No Asset Valuations exist!
    </mat-dialog-content>
</ng-template>
